export default function decimalsFormater(value) {
  const endChar = '0';
  const number = Number(value);
  if (isNaN(number)) {
    return Number(0).toFixed(2);
  }
  const value5 = number.toFixed(5);
  if (!value5.endsWith(endChar)) { return (value5); }
  const value4 = number.toFixed(4);
  if (!value4.endsWith(endChar)) { return (value4); }
  const value3 = number.toFixed(3);
  if (!value3.endsWith(endChar)) { return (value3); }
  return number.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/services/general/decimalsFormater.js